import { Dialog, DialogContent, Box, Typography, Stack, useTheme } from '@mui/material';
import { FiAlertTriangle } from 'react-icons/fi';
import Button from 'components/Common/Button';
import { useState } from 'react';
import { GoPlus } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';

export default function AddBusinessButton() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [addBusinessModalOpen, setAddBusinessModalOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setAddBusinessModalOpen(true)}
        variant='contained'
        color='primary'
        startIcon={<GoPlus />}
        sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: '200px' } }}
      >
        Add Business
      </Button>
      <Dialog
        open={addBusinessModalOpen}
        onClose={() => setAddBusinessModalOpen(false)}
        maxWidth='sm'
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            p: { xs: 3, sm: 5 }
          }
        }}
      >
        <DialogContent sx={{ textAlign: 'center', p: 0 }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              bgcolor: 'warning.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              mx: 'auto'
            }}
          >
            <FiAlertTriangle size={32} color={theme.palette.warning.main} />
          </Box>

          <Typography fontSize={20} fontWeight={500} mb={1.5}>
            Are you sure you want to create a business for your customer?
          </Typography>

          <Typography fontSize={14} color='text.secondary' mb={3}>
            You can create a business directly from here, but we recommend using the Business Onboarding Form for
            customer businesses to ensure proper setup, and configurations.
          </Typography>

          <Box
            sx={{
              bgcolor: 'warning.light',
              borderRadius: '8px',
              p: 2,
              mb: 3,
              textAlign: 'left'
            }}
          >
            <Typography fontWeight={500} color='warning.main' fontSize={14}>
              Recommended for customer businesses:
            </Typography>
            <Typography fontSize={14} color='warning.main'>
              Use the Business Onboarding Form for a smoother and fully guided onboarding experience.
            </Typography>
          </Box>

          <Stack direction='row' justifyContent='end' spacing={2} mb={2} flexWrap='wrap'>
            <Button
              variant='outlined'
              onClick={() => {
                setAddBusinessModalOpen(false);
                navigate('businesses/add');
              }}
              sx={{
                borderRadius: '999px',
                px: 4,
                minWidth: 120,
                borderColor: 'border.main',
                color: 'text.secondary',
                '&:hover': {
                  borderColor: 'border.main',
                  bgcolor: 'transparent'
                }
              }}
            >
              Continue with Business Setup
            </Button>
            <Button
              variant='contained'
              onClick={() => setAddBusinessModalOpen(false)}
              sx={{
                borderRadius: '999px',
                px: 3,
                bgcolor: 'warning.main',
                color: 'common.white',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: 'warning.dark',
                  boxShadow: 'none'
                }
              }}
            >
              Cancel
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
